export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/PaperSourceWeddingBanner-b1fe0a11f9102365e41904d6ca082570.jpg";